import AdditionalMedia from './AdditionalMedia'

export default AdditionalMedia
// eslint-disable-next-line import/export
export * from './AdditionalMedia'
